export const buildMlsSelectOptions = (mlsList) => {
    if (!mlsList.length) return;
    return mlsList
        .filter(mls => mls.isActive)
        .sort((a, b) => a.shortDescription.toLowerCase().localeCompare(b.shortDescription.toLowerCase()))
        .map(mls => ({
            label: `(${mls.shortDescription}) ${mls.longDescription}`,
            value: mls
        }));
};
